import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  getUpdateHistoryDetailsCount,
  GetUpdateHistoryDetailsParams,
} from '@apis/esimBulk/update';

export const useUpdateDetailsCount = (
  updateId: number,
  params?: GetUpdateHistoryDetailsParams
) => {
  const onlyFailed = Boolean(params?.onlyFailed);

  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['updateDetailsCount', updateId, onlyFailed],
    queryFn: () => {
      return getUpdateHistoryDetailsCount(updateId, { onlyFailed });
    },
    enabled: Number.isFinite(updateId) && updateId > 0,
  };
  return useQuery(queryOptions);
};
